import { render } from "./LotteryShow.vue?vue&type=template&id=63513cea&scoped=true"
import script from "./LotteryShow.vue?vue&type=script&lang=js"
export * from "./LotteryShow.vue?vue&type=script&lang=js"

import "./LotteryShow.vue?vue&type=style&index=0&id=63513cea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63513cea"]])

export default __exports__